/**
 * 1、响应拦截  -- 如果 返回值 有错 -- 弹框 （错误）
 *            -- 如果 返回值 error_code == 2000  跳转到登陆页面
 * 2、请求 地址前缀
 * 
 * 3、请求 headers 
 * 
 * 4、请求拦截 -- 如果 请求错误 将错误信息 打印到控制台，并弹框
 * 
 *  */

// import Vue from "vue";

import { Loading } from 'element-ui';
import axios from "axios";
import store from '@/store/index.js'

import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，
import domMessage from "./messageOnce";
// new 对象实例
const messageOnce = new domMessage()


//请求拦截

axios.interceptors.request.use(
    // 在发送请求之前做些什么
    config => {
        if (config.method == 'post') {
            config.url += '? timestamp_ie=' + Date.parse(new Date())
        } else if (config.method == 'get') {
            config.url += '? timestamp_ie=' + Date.parse(new Date())
        }
        // console.log(config)

        return config;
    },
    function(error) {

        console.log(error)

        return Promise.reject(error);
    });

//响应拦截
axios.interceptors.response.use(function(response) {



    return response;
}, function(error) {
    // console.log(error)


    messageOnce.warning({
        message: '服务器错误',
        type: 'danger'
    })

    return console.log(error);

});
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    let loadingInstance = Loading.service({
        text: '请稍等',
        target: document.querySelector('.loading_text')
    })

    return new Promise((resolve, reject) => {

        const token = store.state.sid;
        axios.get(url, {
            params: Object.assign(params, { sid: token }),
        }).then(res => {
            loadingInstance.close();
            console.log(res.data, 'get 传参')
            if (!res.data.fmstatus) {
                alert(res.data);
            } else if (res.data.fmstatus.code == "1") {

                alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
                messageOnce.error({ type: 'danger', message: `${res.data.fmstatus.errmsg}` });

            } else if (res.data.fmstatus.code == "3") {
                messageOnce.error({ type: 'danger', message: `${res.data.fmstatus.errmsg}` });
                window.location.hash = "#/login"
            } else {


                resolve(res.data);



            }
        }).catch(err => {
            loadingInstance.close();
            reject(err.data)
        })
    });
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'



/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        const token = store.state.sid;
        axios.post(url, QS.stringify(Object.assign(params, { sid: token })))
            .then(res => {

                console.log(res, '这是报错')
                if (!res.data.fmstatus) {
                    alert(res.data);
                } else if (res.data.fmstatus.code == "1") {

                    alert(res.data.fmstatus.errmsg);
                } else if (res.data.fmstatus.code == "2") {
                    messageOnce.error({ type: 'danger', message: `${res.data.fmstatus.errmsg}` });

                } else if (res.data.fmstatus.code == "3") {
                    messageOnce.error({ type: 'danger', message: `${res.data.fmstatus.errmsg}` });
                    window.location.hash = "#/login"

                } else {
                    resolve(res.data);

                }


            })
            .catch(err => {
                reject(err.data)
            })
    });
}
// axios.defaults.baseURL="";
// axios.defaults.headers.token="";

export default axios;